import SectionProgress from './SectionProgress';

export default SectionProgress;
